export default (theme) => ({
  progressBar: {
    height: '6px',
    marginBottom: '6px'
  }
})
